import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Signin.css';
import ENV from '../constants/env-constants';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from 'sweetalert2'
import Spinner from '../components/Spinner/Spinner';

function ForgotPassword() {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const location = useLocation()
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Forgot Password' });
  }, []);

  const forgotPasswordFieldValidationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email address').required('Email is required').max(320, 'Max Character limit reached'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: (values, ) => {
      handleSubmit(values);
    },
    validationSchema: forgotPasswordFieldValidationSchema
  });

  const handleSubmit = async ({email}) => {
    setIsButtonLoading(true);
    try {
      const response = await fetch(`${ENV.API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.status === 200) {
        Swal.fire({
          text: "We have sent a password reset link to the email provided if it is associated with an account.",
          icon: "success"
        });
      } else if (response.status === 500) {
        Swal.fire({
          title: "Server Error",
          icon: "error"
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Something went wrong",
        icon: "error"
      });
    }
    setIsButtonLoading(false);
  };

  return (
    <div className="center1">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Change Password</title>
        </Helmet>
        <div className="centercustom center">
          <h1>Change Password</h1>
          <form onSubmit={formik.handleSubmit} className='form'>
            <div className="txt_field">
              <input name='email' type="email" className='custominput' value={formik.values.email} onChange={formik.handleChange} required  />
              <span />
              <label>Email</label>
            </div>
            <div>{formik.errors.email}</div>
            <div onClick={formik.handleSubmit} className='sign-in-submit-button' style={{height: '3rem', display: 'flex', justifyContent: 'center', padding: '0.5rem', alignItems: 'center'}}>
              {isButtonLoading ? <Spinner color="#2691d9"/> : 'Reset Password'}
            </div>
          </form>
        </div>
    </div>
  );
}

export default ForgotPassword;